<div class="w-full pb-[3.5rem]">
  <ng-container *ngIf="!preferentialRateChosen && !noPreferentialRateChosen">
    <div class="flex my-6 items-center clickable-card-parent">
      <div
        class="mx-auto clickable-card flex flex-col mb-4 content-center items-center w-full cursor-pointer"
        (click)="onPreferentialRateChosen()"
        (keydown)="onPreferentialRateChosen()"
        [ngClass]="setClassActive(preferentialRateChosen)">
        <div
          class="flex flex-row items-center place-content-between text-center py-5 px-5"
          style="height: 143px">
          <span>
            {{ resource.preferentialrate.yes }}
          </span>
        </div>
      </div>

      <div
        class="mx-auto clickable-card flex flex-col mb-4 content-center items-center w-full cursor-pointer"
        (click)="onNoPreferentialRateChosen()"
        (keydown)="onNoPreferentialRateChosen()"
        [ngClass]="setClassActive(noPreferentialRateChosen)">
        <div
          class="flex flex-row items-center place-content-between text-center py-5 px-5"
          style="height: 143px">
          <span>
            {{ resource.preferentialrate.no }}
          </span>
        </div>
      </div>
    </div>
    <app-info-bottom
      [popUpInfo]="popupInfo"
      [className]="className"
      [path]="path"></app-info-bottom>
  </ng-container>

  <ng-container *ngIf="preferentialRateChosen && !revenue">
    <div class="flex flex-row mt-6 mb-4 items-center w-full place-content-evenly">
      <div class="custom-inputnumber w-full">
        <p-inputNumber
          [showButtons]="true"
          [formControl]="formPeople.controls.people"
          [step]="1"
          min="1"
          max="10"
          (ngModelChange)="onInputNumberChanges($event)"
          buttonLayout="horizontal"
          decrementButtonClass="custom-decrement"
          incrementButtonClass="custom-increment"
          incrementButtonIcon="pi pi-plus"
          decrementButtonIcon="pi pi-minus"
          class="custom-p-inputnumber w-full" />
      </div>
    </div>
    <div class="flex my-5">
      <button
        pButton
        type="button"
        class="button-NS hover:button-NS focus:button-NS active:button-NS w-full"
        [label]="resource.nextstep.validate"
        icon="pi pi-arrow-right"
        iconPos="right"
        (click)="switchToRevenue()"></button>
    </div>
    <app-info-bottom [popUpInfo]="popupInfoNumberInHome"></app-info-bottom>

    <!-- <button
      pButton
      class="mx-auto mt-4 mb-20 button-outline-call-SV width-max iconSideLabel"
      (click)="onNoPreferentialRate()">
      {{ resource.preferentialrate.noP1 }} {{ cityName }}
    </button> -->
  </ng-container>

  <ng-container *ngIf="revenue">
    <div class="flex gap-3 flex-wrap justify-center my-6 items-center">
      <div
        class="mx-auto clickable-card flex flex-col mb-4 content-center items-center w-full"
        (click)="onRfrInferiorChosen()"
        (keydown)="onRfrInferiorChosen()"
        [ngClass]="setClassActive(rfrInferiorChosen)">
        <div class="flex flex-row items-center place-content-between">
          <p class="two-lines px-6 py-12">
            {{ resource.preferentialrate.inferiorAt }}
            {{ plafondResources | currency : undefined : undefined : '1.0-0' }}
          </p>
        </div>
      </div>

      <div
        class="mx-auto clickable-card flex flex-col mb-4 content-center items-center w-full"
        (click)="onRfrSuperiorChosen()"
        (keydown)="onRfrSuperiorChosen()"
        [ngClass]="setClassActive(rfrSuperiorChosen)">
        <div class="flex flex-row items-center place-content-between">
          <p class="two-lines px-6 py-12">
            {{ resource.preferentialrate.superiorAt }}
            {{ plafondResources | currency : undefined : undefined : '1.0-0' }}
          </p>
        </div>
      </div>

      <div
        class="mx-auto clickable-card flex flex-col mb-4 content-center items-center w-full"
        (click)="onRfrNoAnswerChosen()"
        (keydown)="onRfrNoAnswerChosen()"
        [ngClass]="setClassActive(rfrNoAnswerChosen)">
        <div class="flex flex-row items-center place-content-between">
          <p class="two-lines px-6 py-10 text-center">
            {{ resource.preferentialrate.dontwish }}<br />
            {{ resource.preferentialrate.response }}
          </p>
        </div>
      </div>
    </div>

    <app-info-bottom [popUpInfo]="popupInfoRevenu"></app-info-bottom>
  </ng-container>
</div>

<p-dialog
  [(visible)]="displayModal"
  [modal]="true"
  [style]="{ width: '330px', height: '435px', margin: '1rem' }"
  [closable]="false"
  appendTo="body"
  [showHeader]="false"
  [baseZIndex]="10000">
  <p class="title-P my-5">{{ resource.preferentialrate.preferentialrate }}</p>
  <p class="text-P my-5">{{ resource.preferentialrate.preferentialrate1 }}</p>
  <p class="text-P my-5">{{ resource.preferentialrate.preferentialrate2 }}</p>
  <div class="absolute bottom-0 left-0 right-0 p-4 flex flex-col gap-4 justify-center">
    <button
      pButton
      type="button"
      class="button-NS w-full"
      [label]="resource.nextstep.confirmYourChoice"
      (click)="validatePreferentialRate()"></button>
    <button
      pButton
      type="button"
      class="button-C w-full"
      [label]="resource.nextstep.cancel"
      (click)="cancelPreferentialRate()"></button>
  </div>
</p-dialog>
